import React from 'react';
import { useFieldArray } from 'react-hook-form';
import { styled } from 'linaria/react';
import get from 'lodash/get';
import { capitalize } from 'utils/capitalize';
import { GoodsDimensionsForm } from './goods-dimensions.form';
import { useFilteredInputParams } from '../hooks/use-filtered-input-params';
import { doorsWindowsInputs, useFormConditions } from '../../hooks/use-dimension-form-conditions';
import { goodsHeadings } from '../const';

export const DoorsWindowsForm = () => {
  const doorsFieldsProps = useFieldArray({ name: 'doorsFields' });
  const windowFieldProps = useFieldArray({ name: 'windowsFields' });

  const { inputParameters } = useFilteredInputParams();
  const { hasDoors, hasWindows } = useFormConditions();

  const filteredInputs = doorsWindowsInputs.filter(goods => inputParameters.includes(goods));
  const defaultFilteredInput = get(goodsHeadings, `${filteredInputs[0]}`, '');

  const title = filteredInputs
    .slice(1)
    .reduce(
      (acc, fieldName) => `${acc} и ${goodsHeadings[fieldName]}`,
      `${capitalize(defaultFilteredInput)}`
    );

  return (
    <GoodsDimensionsFormWrapper>
      {hasDoors && (
        <GoodsDimensionsForm name="doorsFields" type="doors" formProps={doorsFieldsProps} title={title} />
      )}
      {hasWindows && (
        <GoodsDimensionsForm
          name="windowsFields"
          type="windows"
          formProps={windowFieldProps}
          title={title}
        />
      )}
    </GoodsDimensionsFormWrapper>
  );
};

const GoodsDimensionsFormWrapper = styled.div`
  @media (--only-mobile) {
    margin-top: var(--space-300);
  }
`;
